import axios from 'axios';
import store from "./layouts/auth/store";
import Vue from "vue";
import { Validator } from 'vee-validate';

/*Definitions*/
const el = document.getElementById('app');
const defaultData = JSON.parse(el.dataset.defaults);
const token = document.head.querySelector('meta[name="csrf-token"]');
const projectKey = defaultData.data?.project?.key;
const path = defaultData.defaults?.path;

/*Store*/
store.commit('default/setDefaults', defaultData.defaults);
store.commit('default/setDefaultData', defaultData.data);

/*Axios*/
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
window.axios.defaults.headers.common['X-Timezone'] = timezone;

if (projectKey) {
    // Set cookie expiration to 1 year from now
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const expires = expirationDate.toUTCString();

    document.cookie = `X-Project-Key=${projectKey}; expires=${expires}; path=${path || '/'}; secure; samesite=Lax`;
    window.axios.defaults.headers.common['X-Project-Key'] = projectKey;
}

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

/*Environment*/
if (process.env.MIX_APP_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

/*Validations*/
Validator.extend('translations', {
    getMessage: field => `The ${field} field is required in default language`,
    validate: (value, id) => {
        if (!value || typeof value !== 'object') {
            return false;
        }
        const key = Array.isArray(id) ? id[0] : id;
        const text = value[key] ?? value[String(key)] ?? value[Number(key)];
        return !!(text && String(text).trim());
    }
});
